import { FormValidatorFn, FormValidationErrors } from '../validators.models';

export const requiredValidatorFn: FormValidatorFn = (value: any) => {
    return (typeof value !== 'undefined' && value.length > 0) ? null : FormValidationErrors.Required;
}
